import { GeneralCatalogItem } from 'data-layer-cr/dist/models';

/**
 * Returns text value from GeneralCatalogItem if it is found
 *
 * @param itemArray - An array of general catalog items where search is taking place
 * @param value - The value that will be used as search criteria
 */
function findFromGeneralCatalog(
  itemArray: GeneralCatalogItem[],
  value: string,
): string {
  const item = itemArray.find((possibleItem) => possibleItem.code === value);
  return item?.name || '';
}

export default findFromGeneralCatalog;
